define("shared/components/shared/ui/dynamic-social-set", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: Shared::SocialIdentity::Item is not Glint-typed yet }}
  <div class="cSS--set cShared--dynamicSocialSet" ...attributes>
    {{#each @socialIdentity.socialProfiles as |socialProfile|}}
      <Shared::SocialIdentity::Item @socialProfile={{socialProfile}} />
    {{/each}}
  </div>
  */
  {
    "id": "w86VxZhs",
    "block": "[[[11,0],[24,0,\"cSS--set cShared--dynamicSocialSet\"],[17,1],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,2,[\"socialProfiles\"]]],null]],null],null,[[[1,\"    \"],[8,[39,2],null,[[\"@socialProfile\"],[[30,3]]],null],[1,\"\\n\"]],[3]],null],[13]],[\"&attrs\",\"@socialIdentity\",\"socialProfile\"],false,[\"each\",\"-track-array\",\"shared/social-identity/item\"]]",
    "moduleName": "shared/components/shared/ui/dynamic-social-set.hbs",
    "isStrictMode": false
  });
  const DynamicSocialSetComponent = (0, _templateOnly.default)();
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, DynamicSocialSetComponent);
});